import React from "react";
import { DotMenu } from "../../assets/icons/DotMenu";
import { useNavigate } from "react-router-dom";

interface IGroupButton {
  text: string;
  icon: any;
  textColorClass?: string;
  onClick?: () => void;
  href?: string;
  disabled?: boolean;
  fontSize?: string;
  ref?: React.MutableRefObject<any>;
  isVisible?: boolean;
}

interface GroupButtonProps {
  buttons?: Array<IGroupButton>;
  styles?: boolean;
}

const ExpenseMenu = ({buttons}:GroupButtonProps) => {
  const nav = useNavigate()
  const [isVisible, setisVisible] = React.useState(false);
  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setisVisible(!isVisible)}
        className="border p-[5px] rounded-lg border-[#EAECF0]"
      >
        <svg
          width={22}
          height={22}
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.003 8.167a2.333 2.333 0 110-4.667 2.333 2.333 0 010 4.667zm0 8.166a2.333 2.333 0 110-4.666 2.333 2.333 0 010 4.666zm0 8.167a2.333 2.333 0 110-4.667 2.333 2.333 0 010 4.667z"
            fill="#344054"
          />
        </svg>
      </button>
      {isVisible && (
        <div className={`absolute   top-10 right-0 z-50`}>
          <div className="bg-[#fff] cursor-pointer py-[10px] rounded-[4px] border-[0.5px] text-[#4E4E4E] border-[#EAECF0] w-[250px] md:w-[220px] p-1">
            {buttons?.map((button, i)=>(
              <button onClick={()=>{
                button.onClick && button.onClick();
                button.href && nav(button.href)
                setisVisible(!isVisible)
              }} className="flex p-2 gap-x-2 hover:bg-slate-50 w-full">
                {button.icon}
                <span className={`text-[${button.textColorClass}]`}>{button.text}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ExpenseMenu;
